const contentMine = () => import('@/pages/content/mine/index.vue');

export default [{
    path: '/content/mine',
    component: contentMine,
    meta: [{
        name: '内容管理',
		activeRoute: '/content/manage'
    },
    {
        name: '个人中心资源位',
        activeRoute: '/content/mine'
    }]
}];